import AuthProvider from './auth_service';
import MemberProvider from './member_service';
import PublicProvider from './public_service';
import UploadfileProvider from './uploadfile_service';
import SurveyProvider from './survey_service';
import AdminProvider from './admin_service';
import KokwatchProvider from './kokwatch_service';
import AgraProvider from './agra_service';


export const authService = new AuthProvider('auth');
export const memberService = new MemberProvider('member');
export const publicService = new PublicProvider('public');
export const uploadFileService = new UploadfileProvider('uploadfile');
export const surveyService = new SurveyProvider('survey');
export const adminService = new AdminProvider('admin');
export const kokwatchService = new KokwatchProvider('kokwatch');
export const agraService = new AgraProvider('agra');